
// Hamburger Animation
$(".hamburger, .js-nav-control").click(function() {
  $(this).toggleClass( "is-active" );
  $('body').toggleClass('open');
});

// Smooth Scroll Animation
var scroll = new SmoothScroll('a[href*="#"]');

// SEARCH 
$('.user-icons').on("click", function(e) {
  $('#search-pop').hide();
});


$("body").on("click", '.js-show-search, .search-close', function(e) {
  e.stopPropagation();
  e.preventDefault();

  if($('#search-pop').is(":visible") && $(window).scrollTop() == 0) {
    $(".index .header").removeClass('header_bar');
    $('.index .header .logo img').attr('src', $('.logo img').data('src-home'));
  } else {
    $(".index .header").addClass('header_bar');
    $('.index .header .logo img').attr('src', $('.logo img').data('src'));
  }

  $('#search-pop').fadeToggle('fast').find('input').focus();
});


// QTY Adjust

/* JS Quantity Incrementers */
jQuery(function(){
  var j = jQuery; 
  var addInput = '.js-qty-wrap'; 

  j(addInput).each(function() { 
    var inputEl = j(this).closest(addInput).find('input');
    var n = inputEl.val(); 
    var plusEl = j(this).closest(addInput).find('.plus');
    var minEl = j(this).closest(addInput).find('.min');
    //On plus click add 1 to n
    plusEl.on('click', function(){
      inputEl.val(++n);
    });
    //On min click 
    minEl.on('click', function(){
    //If n is bigger or equal to 1 subtract 1 from n 
      if ( ( inputEl.val() ) >= 1) {
        inputEl.val(--n);
      } 
    });
  });
});
  
  
$('.js-recipe-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  prevArrow: "<a href='#' class='previous-arrow'><i class='carousel-arrow carousel-arrow-prev'></i></a>",
  nextArrow: "<a href='#' class='next-arrow'><i class='carousel-arrow carousel-arrow-next'></i></a>",
  responsive: [     
    {
      breakpoint: 1024,
      settings: {
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: true,
        centerPadding: '40px',    
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 600,
      settings: {
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
        slidesToScroll: 1,
        dots:true,
        arrows:false,
      }
    }
  ]   
                                 
});

$(window).on('load', function() {
$('.js-collection-carousel').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
  centerMode: false,
  centerPadding: '0',
  prevArrow: "<a href='#' class='previous-arrow'><i class='carousel-arrow carousel-arrow-prev'></i></a>",
    nextArrow: "<a href='#' class='next-arrow'><i class='carousel-arrow carousel-arrow-next'></i></a>",
  responsive: [     
  {
      breakpoint: 1024,
      settings: {
        centerMode: true,
      centerPadding: '40px',
        slidesToShow: 2,
      slidesToScroll: 2,
      }
    },
        {
      breakpoint: 768,
      settings: {
        centerMode: true,
      centerPadding: '40px',
        slidesToShow: 2,
      slidesToScroll: 2,
      }
    },
    {
      breakpoint: 600,
       
        settings: {
      centerMode: true,
    centerPadding: '40px',
        slidesToShow: 1,
    slidesToScroll: 1,
    dots:true,
    arrows:false,
      }
    }
  ]   
                                 
});
});

 
// PDP CAROUSEL WITH THUMBS
  $('.js-slider-primary').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite:true,
    asNavFor: '.js-slider-thumbs'
  });
  $('.js-slider-thumbs').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.js-slider-primary',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    infinite:true,
    variableWidth: false,
    arrows: true,
  prevArrow: "<a href='#' class='previous-arrow'><i class='carousel-arrow carousel-arrow-prev'></i></a>",
  nextArrow: "<a href='#' class='next-arrow'><i class='carousel-arrow carousel-arrow-next'></i></a>",
  });

  

// Footer Nav

function resizeHandler() {
  console.log("window resized");

  if ($(window).width() < 767) {
    console.log("window small than 600");
    
    $('.footer-nav ul').hide();
    $('.footer-nav ul').slideUp(200);
  } else{
     $('.footer-nav ul').show();
     $('.footer-nav-header').removeClass("expanded");
  }
 }

resizeHandler();

$(window).resize(resizeHandler);

$('body').on('click', '.footer-nav-header', function() { 
  if ($(window).width() < 767) {
    $(this).next().slideToggle(200);
    $(this).toggleClass("expanded");
  }
});
